(ns practitest.frontend.components.users
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.format-utils :as fu]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.tooltip :as tooltip]
            [reagent.core :as reagent]
            [re-frame.core :as re-frame]
            ["react-select" :default Select :refer [components]]
            [clojure.string :as str]
            [practitest.frontend.components.lists :as lists]
            [practitest.frontend.subs :as subs]))

(defn find-user [users id]
  (or (first (filter #(and (= id (:id %))
                           (= "user" (:type %)))
                     users))
      ;; Fall back to :missing-users, populated from :referenced_users on
      ;; server responses for users no longer in the project user list.
      (when id
        (get @(re-frame/subscribe [::subs/missing-users]) id))))

(defn user-avatar
  [user]
  (when-let [avatar (:avatar user)]
    (case (:type avatar)
      "icon"
      (let [initials (str/join "" (map first (str/split (:name user) #" " 2)))]
        [:span.avatar-icon {:class (if (:certified user)
                                     "certified_circ"
                                     "noncertified_circ")}
         initials])

      "image"
      [:img.avatar-image {:src   (:url avatar)
                          :class (if (:certified user)
                                   "certified_circ"
                                   "noncertified_circ")}]

      ;default
      "")))

(def custom-option
  (fn [props]
    (let [user (.-data props)
          children (.-children props)]
      (reagent/as-element
        [:r> (.-Option components)
         props
         ;; Override children elements
         [user-avatar user]
         children]))))

(def custom-single-value
  (fn [props]
    (let [user (.-data props)
          children (.-children props)]
      (reagent/as-element
        [:r> (.-SingleValue components)
         props
         ;; Override children elements
         [user-avatar user]
         children]))))

(defn user-selector [{:keys [users-list
                             user]
                      :as   props}]
  [lists/objects-list (assoc props
                        :components #js {:Option      custom-option
                                         :SingleValue custom-single-value}
                        :label-fn (fn [user]
                                    (if (= "group" (:type user))
                                      (str "Group: " (:name user))
                                      (:name user)))
                        :value-fn (fn [user]
                                    (:id user))
                        :value user
                        :options users-list)])

;; Different styles
(defn user-avatar2
  [user]
  (when-let [avatar (:avatar user)]
    [:div.avatar-holder
     {:class (if (:certified user)
               "avatar-certified"
               "avatar-not-certified")}
     (case (:type avatar)
       "icon"
       (let [initials (fu/user-initials (:name user))]
         [:span.new-avatar-icon
          {:class (if (:certified user)
                    "avatar-certified"
                    "avatar-not-certified")}
          initials])

       "image"
       [:img.new-avatar-image
        {:src (or (:url_medium avatar)
                  (:url avatar))}]

       "unassigned"
       (icons/unassigned-avatar)

       ;default
       "")]))

(defn user-collab-avatar
  ([user state]
   (user-collab-avatar user state nil))
  ([user state border-color]
   [tooltip/mux-tooltip
    {:position "top"}
    (:name user)
    (fn [props]
      [:div.collab-avatar-wrapper (merge props {})
       [:div.collab-avatar {:class (dom/classes-pairs "has-border" border-color)
                            :style (when border-color
                                     {"--collab-border-color" border-color})}
        [user-avatar2 user]]
       [:div.state-icon
        (if (= state "active")
          [:span.active
           [icons/online-circle-icon]]
          [:span.idle
           [icons/offline-circle-icon]])]])]))
